// Shared Action Constants used in the v4 Router and v4 position manager
export const MSG_SENDER = '0x0000000000000000000000000000000000000001'
